module.exports = __webpack_public_path__ + "media/images/thumbs/physanims/a1-9-5e54de566cbdd540147790bf1b81a984.jpg";